import { useState } from 'react'
import { Box, Button, Menu, MenuItem, Typography } from '@mui/material'

import { ReactComponent as CaretDown } from '../../../assets/icons/caret-down.svg'
import { ReactComponent as CaretUp } from '../../../assets/icons/caret-up.svg'
import { ReactComponent as EsFlag } from '../../../assets/icons/es.svg'
import { ReactComponent as EnFlag } from '../../../assets/icons/en.svg'
import { ReactComponent as PtFlag } from '../../../assets/icons/pt.svg'

import LOCALES from '../../../i18n/locales'
import { useLocale } from '../../../i18n/LocaleProvider'

import useStyles from './styles'

const FLAGS = {
  es: EsFlag,
  en: EnFlag,
  pt: PtFlag,
}

const LanguageSelector = () => {
  const classes = useStyles()
  const { locale, setLocale } = useLocale()
  const [anchorEl, setAnchorEl] = useState(null)

  const currentOption =
    LOCALES.find(option => option.locale === locale) ?? LOCALES[0]
  const CurrentFlag = FLAGS[currentOption.locale]

  const handleOpen = event => setAnchorEl(event.currentTarget)
  const handleClose = () => setAnchorEl(null)
  const handleSelect = newLocale => {
    setLocale(newLocale)
    handleClose()
  }

  return (
    <>
      <Button
        className={classes.button}
        variant="text"
        onClick={handleOpen}
        endIcon={anchorEl ? <CaretUp /> : <CaretDown />}
      >
        <Box component="span" className={classes.flag}>
          <CurrentFlag title={currentOption.label} />
        </Box>
        {currentOption.locale.toUpperCase()}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        disableScrollLock
      >
        {LOCALES.map(option => {
          const OptionFlag = FLAGS[option.locale]
          return (
            <MenuItem
              key={option.locale}
              className={classes.menuItem}
              selected={option.locale === locale}
              onClick={() => handleSelect(option.locale)}
            >
              <Box component="span" className={classes.flag}>
                <OptionFlag title={option.label} />
              </Box>
              <Typography variant="body2">{option.label}</Typography>
            </MenuItem>
          )
        })}
      </Menu>
    </>
  )
}

export default LanguageSelector
